import ProjectWebscannerSidebarWidgetComponent from './sidebar-widget.component'

const ProjectWebscannerSidebarWidgetModule = angular.module('cdbl.sidebar-webscanner-widget', [

])
  .component('cdblProjectWebscannerSidebarWidget', ProjectWebscannerSidebarWidgetComponent)
  .name

export default ProjectWebscannerSidebarWidgetModule
